"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeReseller_de_de = void 0;
function backofficeReseller_de_de() {
    return {
        "backoffice.reseller.companies.title": "Firmen",
        "backoffice.reseller.projects.title": "Projekte",
        "backoffice.reseller.users.title": "Benutzer",
        "backoffice.reseller.subscriptions.title": "Abonements",
        "backoffice.reseller.bookedsubscriptions.title": "Gebuchte Abonements"
    };
}
exports.backofficeReseller_de_de = backofficeReseller_de_de;
